export default __webpack_public_path__ + "static/media/Design_3CCTests.7d400bd5.png";